import {
  useMemo, useState,
} from 'react';
import {
  Box, Grid, Paper,
  Radio, Stack,
} from '@mui/material';
import { Table } from 'react-bootstrap';
import BlockProps from '../../../models/BlockProps';
import BlockContactData from './BlockContactData';
import ModalComponent from '../../ModalComponent';
import Paginator from '../../Paginator';
import { PaginationMetaLink } from '../../../models/Paginator';

function BlockContact({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockContactData);
  const [accessToken, setAccessToken] = useState('');
  const [failMessage, setFailMessage] = useState<string>(null);
  const [contactFormList, setContactFormList] = useState(null);
  const [isOpenListModal, setIsOpenListModal] = useState(false);

  const staticDefaultLinks = [
    { active: false, label: '&laquo; Previous', url: null } as PaginationMetaLink,
    { active: true, label: '1', url: null } as PaginationMetaLink,
    { active: false, label: 'Next &raquo;', url: null } as PaginationMetaLink,
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  const [total, setTotal] = useState(0);
  const [fromItem, setFromItem] = useState(0);
  const [toItem, setToItem] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [links, setLinks] = useState<PaginationMetaLink[]>(staticDefaultLinks);

  const changePage = (page: number) => {
    // code to update pagination
  };

  const selectRowFromCurrentValue = (url: string | null) => {
    if (!url || !contactFormList) {
      return;
    }

    const selected = contactFormList.find((item: any) => item.iframe_url === url);
    if (selected) {
      setSelectedRow(selected);
    }
  };
  const handleClick = () => {
    if (!isEditing || isTemplate) {
      return;
    }
    setFailMessage('');

    setIsOpenListModal(true);
    selectRowFromCurrentValue(props.html?.value);
  };
  const handleSave = () => {
    props.html.value = selectedRow.iframe_url;
    editHandler(data.id, props);
    setIsOpenListModal(false);
  };

  const handleRadioChange = (item: any) => {
    setSelectedRow(item);
  };

  const trData = useMemo(() => {
    if (contactFormList && contactFormList?.length === 0) {
      return (
        <tr>
          <td colSpan={3} className="text-center">
            一覧がありません。
          </td>
        </tr>
      );
    }

    return (contactFormList && contactFormList?.length > 0) && (
      contactFormList?.map((item: any) => (
        <>
          <tr key={item?.id} onClick={() => handleRadioChange(item)}>
            <td className="text-center px-0">
              <Radio
                value={item?.id}
                checked={selectedRow && selectedRow.id === item.id}
                onChange={() => handleRadioChange(item)}
              />
              選択
            </td>
            <td className="text-center">{item?.id}</td>
            <td>
              {item?.description}
            </td>
          </tr>
        </>
      ))
    );
  }, [contactFormList, selectedRow]);

  const iFrameContent = useMemo(() => {
    if (props.html?.value) {
      return `<iframe title="お問合せ" src=${props.html.value} width="100%" height="500px" />`;
    }
    return null;
  }, [props.html.value]);

  return (
    <>
      <Stack
        spacing={0}
        style={{
          overflow: 'hidden',
        }}
      >
        <Grid
          container
          direction="column"
          sx={{
            justifyContent: 'center', alignItems: 'center', p: 2,
          }}
          onClick={handleClick}
        >
          {props.html.value && (
            <div style={{ pointerEvents: isEditing ? 'none' : 'auto', width: '100%' }}>
              <div style={{ width: '100%', height: '500px' }} dangerouslySetInnerHTML={{ __html: iFrameContent }} />
            </div>
          )}
          {!props.html.value && (
            <Paper
              elevation={0}
              sx={{
                width: '100%', height: 450, background: '#F4F4F6', border: '1px dashed lightGray',
              }}
            >
              <div className="p-1">
                ***ここにお問い合わせが表示される***
              </div>
            </Paper>
          )}
        </Grid>
        {isEditing && !isTemplate && (
          <ModalComponent
            size="xl"
            title="お問合せ選択"
            confirmButtonText="選択する"
            onConfirm={handleSave}
            show={isOpenListModal}
            closeModal={() => setIsOpenListModal(false)}
            centered
            animation={false}
            scrollable
            backdropClassName="z-index-3000"
            style={{ zIndex: 3001 }}
          >
            { failMessage && (
              <Box className="text-danger pb-2">
                {failMessage}
              </Box>
            )}
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="text-center px-0" style={{ minWidth: 90 }}>選択</th>
                  <th className="text-center">No</th>
                  <th>お問合せ</th>
                </tr>
              </thead>
              <tbody>
                {trData}
              </tbody>
            </Table>
            <div className="row mt-1">
              <div className="col-6">
                <div className="paging-info d-flex justify-content-start align-items-center mt-2">
                  <div>
                    {' '}
                    全
                    {' '}
                    {total}
                    {' '}
                    件中
                    {' '}
                    {fromItem}
                    {' '}
                    〜
                    {toItem}
                    {' '}
                    件を表示
                  </div>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-end mt-2">
                <div>
                  <Paginator currentPage={currentPage} changePage={changePage} links={links} />
                </div>
              </div>
            </div>
          </ModalComponent>
        )}
      </Stack>
    </>
  );
}

export default BlockContact;
